<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import { todoComputed, todoMethods} from "@/state/helpers";
import { Helper } from "@/mixin/helper";
import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Work Order',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },

  computed: {
    ...todoComputed,
    title() {
      return this.$t('workOrder.title')
    },
    titleTJ() {
      return this.$t('workOrder.titleTJ')
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  mixins: [Helper],
  methods: {
    ...todoMethods,
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ title }}</span>
            </template>
            <b-row class="mc-card__list">
              <b-col v-if="this.getAccessFunc('validation') || hasAccess('sms-wo-validation:read')" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Work Order Validation' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_checkmark-circle"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('workOrder.column.validation') }}</h4>
                    <p>{{ $t('workOrder.subColumn.validation') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col v-if="this.getAccessFunc('workTime') || hasAccess('sms-wo-timelog:read')"  md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Work Order Work Time' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_clock"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('workOrder.column.workTime') }}</h4>
                    <p>{{ $t('workOrder.subColumn.workTime') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col v-if="this.getAccessFunc('location') || hasAccess('sms-wo-tracking:read')"  md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Work Order Technician Location' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_pin"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('workOrder.column.location') }}</h4>
                    <p>{{ $t('workOrder.subColumn.location') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col v-if="true" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Work Order Done' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_all-done"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('workOrder.column.done') }}</h4>
                    <p>{{ $t('workOrder.subColumn.done') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col v-if="this.getAccessFunc('sop') || hasAccess('sms-sop:read')" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Work Order SOP' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_folder-add"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('workOrder.column.sop') }}</h4>
                    <p>{{ $t('workOrder.subColumn.sop') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col v-if="this.getAccessFunc('stock-technician') || hasAccess('sms-stock-technician:read')" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Stock Technician' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-fill_cube"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('workOrder.column.stockTechnician') }}</h4>
                    <p>{{ $t('workOrder.subColumn.stockTechnician') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col v-if="this.getAccessFunc('location') || hasAccess('sms-training-dataset:read')"  md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Ai Training' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_pin"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('workOrder.column.aiTraining') }}</h4>
                    <p>{{ $t('workOrder.subColumn.aiTraining') }}</p>
                  </div>
                </b-button>
              </b-col>

              <!-- MENU BARU: Dataset Invalid Reason -->
              <b-col v-if="this.getAccessFunc('dataset-invalid-reason') || hasAccess('sms-sop-validation:read')" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Invalid Reason' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_alert-circle"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ 'Dataset Invalid Reason' }}</h4>
                    <p>{{ 'Kelola alasan gambar/dataset tidak valid' }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <!-- Lainnya -->
    <PageHeader :title="`${titleTJ}`" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ title }}</span>
            </template>
            <b-row class="mc-card__list">
              <b-col v-if="this.getAccessFunc('validation') || hasAccess('sms-wo-validation:read')" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Work Order Validation TJ' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_checkmark-circle"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('workOrder.column.validation') }}</h4>
                    <p>{{ $t('workOrder.subColumn.validation') }}</p>
                    <div style="display: flex; gap: 5px; margin-top: 5px;">
                      <b-badge pill style="background-color: cornflowerblue; padding: 5px">
                        Transjakarta
                      </b-badge>
                      <b-badge pill style="background-color: cornflowerblue; padding: 5px">
                        Adarotama Inti Sentosa
                      </b-badge>
                    </div>
                  </div>
                </b-button>
              </b-col>

              <b-col v-if="true" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Work Order Done TJ' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_all-done"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('workOrder.column.done') }}</h4>
                    <p>{{ $t('workOrder.subColumn.done') }}</p>
                    <div style="display: flex; gap: 5px; margin-top: 5px;">
                      <b-badge pill style="background-color: cornflowerblue; padding: 5px">
                        Transjakarta
                      </b-badge>
                      <b-badge pill style="background-color: cornflowerblue; padding: 5px">
                        Adarotama Inti Sentosa
                      </b-badge>
                    </div>
                  </div>
                </b-button>
              </b-col>
              
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
